<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Create timeslot</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <h2 class="text-info font-weight-bold">Event details</h2>
        <dl v-if="event" class="row">
          <dt class="text-info font-weight-bold col-sm-3">Name</dt>
          <dd class="text-info font-weight-bold col-sm-9">{{ event.name }}</dd>
          <dt class="text-info font-weight-bold col-sm-3">Date</dt>
          <dd class="text-info font-weight-bold col-sm-9">{{ formatDate(event.date) }}</dd>
        </dl>

        <h2 class="text-info font-weight-bold">Function details</h2>
        <dl class="row">
          <dt class="text-info font-weight-bold col-sm-3">Code</dt>
          <dd class="text-info font-weight-bold col-sm-9">
            {{ Object.keys(selectedFunction).length > 0 ? selectedFunction.code : '/' }}
          </dd>
          <dt class="text-info font-weight-bold col-sm-3">Location</dt>
          <dd class="text-info font-weight-bold col-sm-9">
            {{ Object.keys(selectedFunction).length > 0 ? selectedFunction.sub_location?.location.name : '/' }}
          </dd>
          <dt class="text-info font-weight-bold col-sm-3">Sublocation</dt>
          <dd class="text-info font-weight-bold col-sm-9">
            {{ Object.keys(selectedFunction).length > 0 ? selectedFunction.sub_location?.name : '/' }}
          </dd>
          <dt class="text-info font-weight-bold col-sm-3">Description</dt>
          <dd class="text-info font-weight-bold col-sm-9">{{
              Object.keys(selectedFunction).length > 0 ? selectedFunction.description : '/'
            }}
          </dd>
        </dl>

        <h2>Timeslot details</h2>
        <form @submit.prevent="submitTimeslot">

          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="timeslotData.name" ref="nameInput" required
                   placeholder="Timeslot name"/>
          </div>

          <div class="mb-3">
            <label for="quantity" class="form-label">Quantity</label>
            <input type="number" class="form-control" id="quantity" v-model="timeslotData.quantity" required
                   placeholder="Number of crew members needed" ref="quantityInput"/>
          </div>

          <div class="mb-3">
            <label for="position" class="form-label">Function</label>
            <div v-for="thisFunction in functions" :key="thisFunction.id" class="form-check">
              <input class="form-check-input" type="radio" :id="'function-' + thisFunction.id" :value="thisFunction.id"
                     v-model="timeslotData.function_id" required>
              <label class="form-check-label" :for="'function-' + thisFunction.id">{{ thisFunction.code }}</label>
            </div>
          </div>


          <div class="mb-3">
            <label for="start_datetime" class="form-label">Start date and time</label>
            <input type="datetime-local" class="form-control" id="start_datetime" v-model="timeslotData.start"
                   required
                   placeholder="Shift start date and time"/>
          </div>
          <div class="mb-3">
            <label for="end_datetime" class="form-label">End date and time</label>
            <input type="datetime-local" class="form-control" id="end_datetime" v-model="timeslotData.end" required
                   placeholder="Shift end date and time"/>
          </div>

          <p class="text-info font-weight-bold">Timeslot length: {{ shiftLength() }} hours</p>

          <div class="mb-3">
            <label for="default_slot_length" class="form-label">Default slot length (HH:MM)</label>
            <input type="text" class="form-control" id="default_slot_length" v-model="timeslotData.default_slot_length"
                   placeholder="HH:MM"/>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="isSubmitButtonDisabled" @click="submitFunction">
          Create timeslot
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: 'CreateFunctionModal',
  props: {
    event: {
      type: Object,
      required: false,
    },
    locations: {
      type: Array,
      required: true,
    },
    functions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      timeslotData: {
        start: '',
        end: '',
        quantity: '',
        function_id: null,
        event_id: this.event.id,
        default_slot_length: '02:00',
      },
    };
  },
  watch: {
    'timeslotData.function_id': "suggestedStart",

  },
  computed: {
    selectedFunction() {
      return this.functions.find(func => func.id === this.timeslotData.function_id) || {};
    },

    isSubmitButtonDisabled() {
      return this.timeslotData.name === '' ||
          this.timeslotData.start === '' ||
          this.timeslotData.end === '' ||
          this.timeslotData.quantity === '' ||
          this.timeslotData.function_id === null ||
          this.timeslotData.default_slot_length === null
          ;
    },
  },
  mounted() {
    this.$refs.nameInput.focus();
    // this.setStartAndEndDateTime();
    console.log("Functions array:", this.functions);
  },
  methods: {
    setStartAndEndDateTime(startDate = this.event.date, startHour = this.event.default_shift_start_time, shiftLengthHoursMinutesSeconds = this.event.default_shift_duration) {
      console.log("setStartAndEndDateTime", startDate, startHour, shiftLengthHoursMinutesSeconds);
      // Create time zone aware datetime object
      const startDateTime = dayjs(`${startDate}T${startHour}`);
      // Drop the time zone information for use in the datetime-local input field
      this.timeslotData.start = startDateTime.format('YYYY-MM-DDTHH:mm');

      // Split shiftLengthHoursMinutesSeconds into hours, minutes and seconds
      const [hours, minutes] = shiftLengthHoursMinutesSeconds.split(':').map(Number);

      // Add hours, minutes and seconds to the start time to get the end time
      const endDate = startDateTime.add(hours, 'hour').add(minutes, 'minute');
      // Drop the time zone information for use in the datetime-local input field
      this.timeslotData.end = endDate.format('YYYY-MM-DDTHH:mm');
    },
    shiftLength() {
      if (this.timeslotData.start && this.timeslotData.end) {
        const start = dayjs(this.timeslotData.start);
        const end = dayjs(this.timeslotData.end);
        return dayjs.duration(end.diff(start)).asHours().toFixed(2);
      }
      return "/";
    },
    parseDuration(duration) {
      const [hours, minutes] = duration.split(':').map(Number);
      return dayjs.duration({hours, minutes}).toISOString();
    },
    submitFunction() {
      // Set the start and end values in UTC mode and formatted correctly
      this.timeslotData.start = dayjs(this.timeslotData.start).utc().format('YYYY-MM-DDTHH:mm');
      this.timeslotData.end = dayjs(this.timeslotData.end).utc().format('YYYY-MM-DDTHH:mm');
      this.timeslotData.default_slot_length = this.parseDuration(this.timeslotData.default_slot_length);
      console.log("About to submit the TimeSlot ", this.timeslotData);
      this.$emit('create-timeslot', this.timeslotData);
      this.$emit('close');
    },
    handleEnterKey() {
      if (!this.isCreateButtonDisabled) {
        this.submitFunction();
      }
    },
    formatDate(date) {
      return dayjs(date).format('dddd DD/MM/YYYY');
    },
    suggestedStart() {
      // Search for timeslots on the same function of the selected event
      // let matching_event_timeslots = this.event.timeslots.filter(timeslot => timeslot.function_id === this.timeslotData.function_id);
      // console.log("Matching timeslots", matching_event_timeslots);
      console.log("Selected function", this.selectedFunction);
      // Get the timeslot for this event and function with the largest end time
      let matching_timeslots = this.event.timeslots.filter(timeslot => timeslot.function.id === this.timeslotData.function_id);
      console.log("Matching timeslots", matching_timeslots);
      if (matching_timeslots.length > 0) {
        let latest_timeslot = matching_timeslots.reduce((a, b) => a.end > b.end ? a : b);
        console.log("Latest timeslot", latest_timeslot);
        const endTimeLocal = dayjs(latest_timeslot.end).local();
        this.setStartAndEndDateTime(endTimeLocal.format('YYYY-MM-DD'), endTimeLocal.format('HH:mm'), this.event.default_shift_duration);
      } else {
        this.setStartAndEndDateTime();


      }
    }
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}
</style>